module.exports = __webpack_public_path__ + "static/media/55.a3a40b9.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/55.wav
// module id = Jia4
// module chunks = 0